import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Fire-and-forget lead funnel event tracking. Never blocks the UX.
export async function trackEvent(event, meta = {}) {
  try {
    await axios.post(`${API}/events`, {
      event,
      path: typeof window !== "undefined" ? window.location.pathname : "",
      referrer: typeof document !== "undefined" ? document.referrer : "",
      meta,
    });
  } catch (e) {
    // Analytics must never break the funnel.
    console.warn("trackEvent failed", event);
  }
}

export { API };
